import { Platform } from 'react-native';
const base = {
    backgroundColor: '#fff',
    shadowColor: '#172A41',
    shadowOpacity: 0.1,
};
const shadows = {
    [-1]: {
        backgroundColor: '#fff',
    },
    0: Object.assign(Object.assign({}, base), { shadowColor: undefined, shadowOpacity: undefined, borderColor: '#E7EDF5', borderStyle: 'solid', borderWidth: 1 }),
    1: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 4,
        }, shadowRadius: 10 }), Platform.select({
        ios: {
            shadowRadius: 4,
        },
        android: {
            elevation: 4
        }
    })),
    2: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 7,
        }, shadowRadius: 20 }), Platform.select({
        android: {
            elevation: 7
        }
    })),
    3: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 20,
        }, shadowRadius: 20 }), Platform.select({
        android: {
            elevation: 20
        }
    })),
    4: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 30,
        }, shadowRadius: 30 }), Platform.select({
        android: {
            elevation: 30
        }
    })),
    5: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 50,
        }, shadowRadius: 50 }), Platform.select({
        ios: {
            shadowRadius: 30,
        },
        android: {
            elevation: 50
        }
    })),
    6: Object.assign(Object.assign(Object.assign({}, base), { shadowOffset: {
            width: 0,
            height: 60,
        }, shadowRadius: 60 }), Platform.select({
        ios: {
            shadowRadius: 35,
        },
        android: {
            elevation: 100
        }
    }))
};
export const Shadow = {
    level(number) {
        return (shadows[number] || {});
    }
};
